import { sendDataLayerEvent } from '@utils/send-data-layer-event/send-data-layer-event';

export type AuthStatus = 'authenticated' | 'unauthenticated';

/**
 * @description Push a sanitized auth_state event into the dataLayer for GTM/GA4.
 * - For authenticated users, includes a string user_id.
 * - For unauthenticated users, never includes user_id.
 */
export const pushAuthState = (status: AuthStatus, userId?: string | number) => {
  const raw = userId != null ? String(userId) : '';
  const sanitized = raw.trim();
  const hasValidUserId = Boolean(sanitized) && sanitized.toLowerCase() !== 'null' && sanitized.toLowerCase() !== 'undefined';

  if (status === 'authenticated' && hasValidUserId) {
    sendDataLayerEvent({
      event: 'auth_state',
      auth_status: 'authenticated',
      user_id: sanitized,
    });
  } else {
    // unauthenticated OR invalid id: push without user_id
    sendDataLayerEvent({
      event: 'auth_state',
      auth_status: 'unauthenticated',
    });
  }
};
